/**
 * Microsoft four-square mark (SC-2720). Inlined as an SVG rather than a remote
 * asset so the login page has no external image dependency (same rationale as
 * GoogleGlyph). The four brand hexes are fixed by Microsoft's sign-in branding
 * guidelines — the documented exception to the theme-token rule (like the
 * bespoke hardcoded login palette in LoginPage.css).
 */
export function MicrosoftGlyph({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 21 21" aria-hidden="true" focusable="false">
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  );
}
